import React, { useEffect, useState } from "react";
import { useRouteTransition } from "@/contexts/RouteTransitionContext";

export default function TopProgressBar() {
  const { isPending } = useRouteTransition();
  const [visible, setVisible] = useState(false);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    let timer: NodeJS.Timeout;
    let progressTimer: NodeJS.Timeout;

    if (isPending) {
      setVisible(true);
      setProgress(10);
      
      progressTimer = setInterval(() => {
        setProgress((prev) => {
          if (prev >= 90) return prev;
          // Ease-out progress calculation (slows down as it approaches 90%)
          return prev + (90 - prev) * 0.15;
        });
      }, 100);
    } else {
      setProgress(100);
      timer = setTimeout(() => {
        setVisible(false);
        setProgress(0);
      }, 300); // Wait for fade transition before hiding completely
    }

    return () => {
      clearTimeout(timer);
      clearInterval(progressTimer);
    };
  }, [isPending]);

  if (!visible) return null;

  return (
    <div
      className="fixed top-0 left-0 right-0 z-[9999] h-[3px] w-full transition-all duration-300"
      style={{
        opacity: progress === 100 ? 0 : 1,
        pointerEvents: "none",
      }}
    >
      <div
        className="h-full bg-gradient-to-r from-blue-500 via-indigo-500 to-purple-600 shadow-[0_1px_8px_rgba(99,102,241,0.5)] transition-all ease-out"
        style={{
          width: `${progress}%`,
          transitionDuration: progress === 100 ? "300ms" : "200ms",
        }}
      />
    </div>
  );
}
